import React from 'react';
import './Follow.scss'

class Follow extends React.Component {
	render() {
		const pic = require('../../asstes/img/follow/code-img.jpg')
		return <div className="follow-container">
			<img className="follow-pic" src={pic} alt=""/>
		</div>
	}
}

export default Follow;